import { CLOSE_PATAGONIA_ONBOARDING_MODAL, OPEN_PATAGONIA_ONBOARDING_MODAL } from './ActionTypes';
export const openPatagoniaOnboardingModal = () => {
  return {
    type: OPEN_PATAGONIA_ONBOARDING_MODAL
  };
};
export const closePatagoniaOnboardingModal = () => {
  return {
    type: CLOSE_PATAGONIA_ONBOARDING_MODAL
  };
};